import { inject, injectable } from 'inversify';
import { EventDependencyTypes, type EventManager, type ListenerInterface } from '@kiplin/web-common/event';
import { ModalCloseEndEvent } from '@kiplin/web-common/modal';
import { MainLayoutDependencyTypes } from '@client/composition/main-layout/main-layout.dependency-types';
import type { MainLayoutStoreCommand } from '@client/composition/main-layout/domain/store/main-layout.store-command';
import { GAME_CREATION_MODAL_ID } from '@client/feature/game-creation/domain/constant/game-creation-modal-id.constant';
import { GameCreationModalOpenRequestedEvent } from '@client/feature/game-creation/domain/event/game-creation-modal-open-requested.event';

@injectable()
export class MainLayoutGameCreationModalLifecycleListener implements ListenerInterface {
  private readonly onOpenRequested = (): void => {
    this.mainLayoutStoreCommand.setIsCreateGameModalUiReady(true);
  };

  private readonly onCloseEnd = (): void => {
    this.mainLayoutStoreCommand.setIsCreateGameModalUiReady(false);
  };

  public constructor(
    @inject(EventDependencyTypes.EventManager)
    private readonly eventManager: EventManager,
    @inject(MainLayoutDependencyTypes.MainLayoutStoreCommand)
    private readonly mainLayoutStoreCommand: MainLayoutStoreCommand,
  ) {}

  public activate(): void {
    this.eventManager.addListener(GameCreationModalOpenRequestedEvent, this.onOpenRequested);
    this.eventManager.addListener(ModalCloseEndEvent, this.onCloseEnd, {
      keySuffix: GAME_CREATION_MODAL_ID,
    });
  }

  public deactivate(): void {
    this.eventManager.removeListener(GameCreationModalOpenRequestedEvent, this.onOpenRequested);
    this.eventManager.removeListener(ModalCloseEndEvent, this.onCloseEnd, {
      keySuffix: GAME_CREATION_MODAL_ID,
    });
  }
}
